import { ToggleButtonPill } from '@hungryroot/ramen';
import {
  useFoodFeedbackNever,
  type UseFoodFeedbackNeverProps,
} from './useFoodFeedbackNever';
import styles from './FoodFeedbacks.module.css';

export function FoodFeedbacks(props: UseFoodFeedbackNeverProps) {
  const { renderNeverToggle, onToggleNever, isToggleSelected } =
    useFoodFeedbackNever(props);

  if (renderNeverToggle) {
    return (
      <ToggleButtonPill
        onPress={onToggleNever}
        label="I never want this"
        isSelected={isToggleSelected}
        className={styles['food-feedbacks-pill']}
      />
    );
  }
  return null;
}
